// @ts-nocheck
import React from 'react';
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import ArrowForwardIosOutlinedIcon from '@material-ui/icons/ArrowForwardIosOutlined';
import Store from '../redux/store';
import ShoppingCart from '../modules/shopping-cart';
import { getSettingInfo } from '../tools/get-setting-info';
import moment from 'moment-timezone';
import { DefaultRequest } from '../requests/default.request';
import { withSnackbar, WithSnackbarProps } from 'notistack';
import { MessengerModule } from "../messenger/module";
import { TurnInfo, SettingInfo } from '../constants/type.constant';
import { WebsocketClient } from '../websocket/module';
import { CartCommitEventObject, DistributionIdEventObject } from '../websocket/type';
import _ from 'lodash';
import i18n from '../i18n';
import { StateManager } from '../redux/stateManager';
import { getCacheField } from '../tools/get-cache-field';
import { GuideTooltips } from './tooltip.component';
import PersonIcon from '@material-ui/icons/Person';
import { UpdateCart, InitCart } from '../websocket/cart2';
import ServerShoppingCart from '../modules/server-shopping-cart';
import { setLocalDateByDiff, getSeverAndLoacalDiff } from '../tools/local-moment';

class Floating extends React.PureComponent<Props, State> {
    public messengerModule: MessengerModule;
    public dishTimer!: NodeJS.Timeout;
    public diffTimeStamp: number = 0;
    public setDisableFalse: NodeJS.Timeout;

    // 自主点餐
    autonomous: { status: boolean } = { status: true };

    public state: State = {
        // 是否展示弹窗
        hideModal: false,
        // 是否等待下一轮
        waitForNextTurn: false,
        // 倒计时时间戳
        showTimeString: 0,
        // 最大点餐数量
        turn_dishes: 0,
        // 每轮次分钟数
        turn_mins: 0,
        // 当前轮次已点数
        turnCount: 0,
        // 上一轮用户点的历史数量
        historyDishNum: 0,
        // 轮次规则
        // turnInfo: getCacheField('turnInfo'),
        // 开桌点餐相关规则
        settingInfo: getCacheField('settingInfo'),
        // 人数
        person: getCacheField('orderTab.person'),
        // 自主点餐
        // autonomous: {
        //     status: true
        // },
        // 用户选中ID 后显示气泡
        updateToolTipStatus: StateManager.getFromCache('guidePageHideDishes') ? true : false,
        // 记录用户第一次进入，是否显示气泡
        guidePageHideDishes: StateManager.getFromCache('guidePageHideDishes'),
        // 桌台id--用于触发视图render
        tableId: 0,
    };

    constructor(props: Props) {
        super(props);
        this.messengerModule = new MessengerModule(this.props.enqueueSnackbar);
        this.diffTimeStamp = Store.getState().diffTimeStamp;
    };

    public async UNSAFE_componentWillMount() {
        // 缓存中的桌台状态
        let resultTableStatus = StateManager.getFromCache('tableStatusById');
        if (_.isEmpty(resultTableStatus)) {
            resultTableStatus = await DefaultRequest.getTableSById(StateManager.getFromCache('tableId'));
            // 当前桌台状态存入缓存
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'tableStatusById',
                value: resultTableStatus,
            })
        }
        // 初始化订单ID
        if (_.get(resultTableStatus, '0.order_head_id')) {
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'orderTab.orderId',
                value: _.get(resultTableStatus, '0.order_head_id')
            })
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'orderTab.person',
                value: _.get(resultTableStatus, '0.customer_num')
            })

            // (逻辑加固, 未知原因，扫码进入可能拿不到桌台名，导致打印小票时，无法显示桌台号)
            if (!getCacheField('tableName')) {
                Store.dispatch({
                    type: 'SET_CACHING',
                    path: 'tableName',
                    value: _.get(resultTableStatus, '0.table_name'),
                })
            };

            this.setState({ person: _.get(resultTableStatus, '0.customer_num', 1) }, () => this.initDishRules())

        }
        // $ 监听用户第一次加入（弃用）
        // WebsocketClient.addListener('FIRST_JOIN', this.firstJosnListener);
    }
    public async componentDidMount() {
        clearInterval(this.dishTimer);
        ServerShoppingCart.disableToNext = false;
        // 初始化点餐规则
        await this.setAutonomous();

        // 已经审核通过 && customer && 重新获取轮次规则
        getCacheField('approvalStatus') === 'NO' && this.props.customer && this.getOrderTurnSSC();

        // // 初始化菜品相关规则
        this.initDishRules();

        // 提交购物车 commitCart
        // $ 分配顾客ID后, 触发轮次统计方法
        WebsocketClient.addListener('DISTRIBUTION_ID', this.disTributionIdListener)

        // $ 监听自己的购物车提交
        WebsocketClient.addListener('CART_COMMIT_QOP', this.cartCommitListener);

        // $ 监听其他设备购物车提交
        WebsocketClient.addListener('CART_COMMIT_OTHER', this.cartCommitOrderListener);

        // $ 监听新手指引提示气泡
        WebsocketClient.addListener('BUBBLE_PROMPT', this.bubblePrompt);

        // $ 接收 其他顾客清空购物车的通知(弃用)
        // WebsocketClient.addListener('DELETE_DISH', this.delectDishListener);

        // $ 监听新手引导 （菜单页）关闭
        WebsocketClient.addListener('GUIDE_DISH_UPDATE', this.guideDishUpdate);

        // $ 更新其他设备菜品的计数（弃用）
        // WebsocketClient.addListener('UPDATE_DISH_COUNT', this.updateDishCountListener)

        // $ 更新自己的浮窗计数（弃用）
        // WebsocketClient.addListener('UPDATE_DISH_COUNT_SELF', this.updateDishCountSelfListerner)

        // $ 监听转台后订单桌台信息更新
        WebsocketClient.addListener('UPDATE_ORDER_TABLE', this.updateOrderTable);

        // ***************
        // 服务端购物车
        // ***************

        // $ 监听初始化购物车
        WebsocketClient.addListener('INIT_CART', this.initCartListener);
        // $ 监听购物车变化，更新悬浮窗计数
        WebsocketClient.addListener('UPDATE_CART', this.updateCartListener);
        // $ 监听轮次推进
        WebsocketClient.addListener('TO_NEXT_TURN', this.toNextTurnListener);

    }

    // 销毁
    public componentWillUnmount() {
        clearInterval(this.dishTimer);
        this.setDisableFalse && clearTimeout(this.setDisableFalse);
        // WebsocketClient.removeListener('UPDATE_DISH_COUNT', this.updateDishCountListener);
        // WebsocketClient.removeListener('UPDATE_DISH_COUNT_SELF', this.updateDishCountSelfListerner)
        WebsocketClient.removeListener('DISTRIBUTION_ID', this.disTributionIdListener);
        WebsocketClient.removeListener('CART_COMMIT_QOP', this.cartCommitListener);
        WebsocketClient.removeListener('CART_COMMIT_OTHER', this.cartCommitOrderListener);
        // WebsocketClient.removeListener('FIRST_JOIN', this.firstJosnListener);
        // WebsocketClient.removeListener('DELETE_DISH', this.delectDishListener);
        WebsocketClient.removeListener('GUIDE_DISH_UPDATE', this.guideDishUpdate)
        WebsocketClient.removeListener('BUBBLE_PROMPT', this.bubblePrompt)
        WebsocketClient.removeListener('UPDATE_ORDER_TABLE', this.updateOrderTable);
        WebsocketClient.removeListener('UPDATE_CART', this.updateCartListener);
        WebsocketClient.removeListener('INIT_CART', this.initCartListener);
        WebsocketClient.removeListener('TO_NEXT_TURN', this.toNextTurnListener);
        this.setState = (state, callback) => { return; };
    }

    /**
     *  $ 监听通讯事件
     */
    public updateOrderTable = () => { this.setState({ tableId: getCacheField('tableId') }) };

    // 监听新手引导（菜单页）关闭
    public guideDishUpdate = () => {
        this.setState({
            guidePageHideDishes: StateManager.getFromCache('guidePageHideDishes')
        })
    }
    // // 监听用户删除购物车
    // public delectDishListener = (data: DeleteDishEventObject) => {
    //     ShoppingCart.metaData = data.dish
    //     Store.dispatch({
    //         type: 'SET_CACHING',
    //         path: 'shoppingCart',
    //         value: ShoppingCart.metaData
    //     })
    // }
    // 监听新手指引提示气泡
    public bubblePrompt = () => {
        this.setState({ updateToolTipStatus: true })
    }
    // 监听用户选中ID
    public disTributionIdListener = async (data: DistributionIdEventObject) => {
        console.log('监听用户选中ID');
        // ShoppingCart.metaData = getCacheField('shoppingCart');
        // getCacheField('personArr').forEach((person: string) => {
        //     // 检查轮次是否存在
        //     if (!_.has(ShoppingCart.metaData, `${ShoppingCart.globalRound}`)) {
        //         _.set(ShoppingCart.metaData, `${ShoppingCart.globalRound}`, {});
        //     }
        //     // 检查顾客是否存在
        //     if (!_.has(ShoppingCart.metaData, `${ShoppingCart.globalRound}.${person}`)) _.set(ShoppingCart.metaData, `${ShoppingCart.globalRound}.${person}`, []);
        // })
        // $ 用户选择id前，视图已经生成， 要监听顾客选择对应ID后更新菜品的计数
        WebsocketClient.emit('UPDATE_DISH', {
            event: 'UPDATE_DISH',
            customer: data.customer,
            turnInfo: getCacheField('turnInfo')
        })
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'orderTab.customer',
            value: data.customer
        })
        getCacheField('approvalStatus') === 'NO' && this.orderGetOrderTurnSSC();
    }
    //  监听其他设备的购物车提交
    public cartCommitOrderListener = async (data: CartCommitEventObject) => {
        clearInterval(this.dishTimer)
        let cacheData = StateManager.getFromCache(['orderTab', 'advGlobalRound']);
        let advGlobalRound = cacheData['advGlobalRound'];
        let orderId = cacheData['orderTab']['orderId'];
        let customer = cacheData['orderTab']['customer'];
        // 轮次规则
        let turnInfo = data.turnInfo;
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'turnInfo',
            value: turnInfo
        })
        // $ 初始化购物车历史记录
        const cartHistory = await DefaultRequest.getHistoryDish(
            orderId,
            Store.getState().settingInfo[0] ? Store.getState().settingInfo[0].value.menu_id : 9,
            'round,dish,type,rule'
        )
        // 更新自主点餐模式
        ShoppingCart.historyDishNumMetaData = cartHistory.dish_round_customer_data;
        ShoppingCart.historyDishRulesMetaData = cartHistory.dishRuleData;

        // $  是否同一设备的用户, true 则更新浮窗数量
        if (data.customer === customer) {
            // $ 统计当前轮次提交的历史数量
            let historyDishNum: number = 0;
            Object.keys(cartHistory.dish_round_customer_data).forEach((itemKey) => {
                if (_.has(cartHistory.dishRuleData, `${itemKey}`) && _.get(cartHistory.dishRuleData, `${itemKey}.not_joining_global_limit`) !== 1) {
                    if (_.has(cartHistory.dish_round_customer_data, `${itemKey}.${advGlobalRound}.${customer}`)) {
                        historyDishNum += _.get(cartHistory.dish_round_customer_data, `${itemKey}.${advGlobalRound}.${customer}`);
                    }
                }
            })
            // historyDishNum = turnInfo.customer_dish_num[customer] ? turnInfo.customer_dish_num[customer] : 0;
            if (historyDishNum >= this.state.turn_dishes) {
                historyDishNum = this.state.turn_dishes
            }
            this.setState({ historyDishNum });
        }
        // let isCountDown = false;
        // // 非自助点餐
        // if (!ShoppingCart.GLOBAL_SELF_ORDER_RULE) isCountDown = true;

        // this.initializeTurnData(turnInfo, isCountDown);
        this.initTrunInfoSSC(turnInfo);
    }
    //  分析此方法 监听用户第一次加入(弃用)
    // public firstJosnListener = (data: FirstJoinEventObject) => {
    //     console.log('用户第一次加入', data.dish)
    // const CUSTOMER = getCacheField('orderTab.customer');
    // const turnInfo = getCacheField('turnInfo');
    // ShoppingCart.metaData = data.dish
    // Store.dispatch({
    //     type: 'SET_CACHING',
    //     path: 'shoppingCart',
    //     value: data.dish
    // })
    // let currentTurnCound = 0;

    // // 统计现有的购物车菜品数量r
    // ShoppingCart.globalRound = data.round
    // if (_.has(ShoppingCart.metaData, `${data.round}.${CUSTOMER}`)) {
    //     Object.values(ShoppingCart.metaData[data.round][CUSTOMER]).forEach((customerItem) => {
    //         if (customerItem._origin.not_joining_global_limit !== 1) {
    //             currentTurnCound += customerItem.count + customerItem.excessCount
    //         }
    //     })
    // }

    // // $ 上一轮提交的菜品数量
    // const DISHCOUNT = _.get(turnInfo, `customer_dish_num.${CUSTOMER}`) ? turnInfo.customer_dish_num[CUSTOMER] : 0;
    // // alert(`监听设备FIRST_JOIN：上一轮提交的菜品数量：${DISHCOUNT}，
    // // 统计现有数量：${currentTurnCound}，是否在倒计时：${Store.getState().isShowTime},当前轮次：${ShoppingCart.globalRound}`)
    // // 是否在倒计时
    // if (Store.getState().isShowTime) {
    //     this.setState({
    //         historyDishNum: DISHCOUNT,
    //         turnCount: (DISHCOUNT + currentTurnCound),
    //     }, () => { this.initializeTurnData(Store.getState().turnInfo) });
    // } else {
    //     this.setState({
    //         turnCount: currentTurnCound,
    //     }, () => { this.initializeTurnData(Store.getState().turnInfo) });
    // }
    // }

    /**
     * 设置点餐规则
     */
    public async setAutonomous() {
        // 系统设置不存在
        if (getSettingInfo('rule-global-turn-max-number', 'value') === null) {
            // 获取系统设置
            let settingInfo = await DefaultRequest.getSettingInfo();
            // 存入缓存
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'settingInfo',
                value: settingInfo
            });
        }
        // 轮次最大回合数
        ShoppingCart.globalRoundMax = getSettingInfo('rule-global-turn-max-number', 'value');
        // 全局自助点餐规则
        const AUTONOMUS = getSettingInfo('rule-autonomous-meal', 'value');
        this.autonomous = AUTONOMUS;
        ShoppingCart.GLOBAL_SELF_ORDER_RULE = AUTONOMUS && AUTONOMUS.status;
    }

    // // $ 监听用户选中ID（其他用户进入初始化一遍）重新获取轮次规则
    // public async orderGetOrderTurn() {
    //     // 清除轮次倒计时
    //     const ORDERID = StateManager.getFromCache('orderTab.orderId')
    //     const CUSTOMER = getCacheField('orderTab.customer');
    //     try {
    //         let settingInfo = getCacheField('settingInfo')
    //         // 轮次规则
    //         let turnInfo = await DefaultRequest.getTurnInfo(
    //             ORDERID,
    //             _.get(settingInfo, '0.value.menu_id', 9)
    //         );
    //         let currentTurnCound = 0;
    //         // 统计现有的购物车菜品数量
    //         if (_.has(ShoppingCart.metaData, `${ShoppingCart.globalRound}.${CUSTOMER}`)) {
    //             Object.values(ShoppingCart.metaData[ShoppingCart.globalRound][CUSTOMER]).forEach((customerItem) => {
    //                 if (customerItem._origin.not_joining_global_limit !== 1) {
    //                     currentTurnCound += customerItem.count + customerItem.excessCount
    //                 }
    //             })
    //         }
    //         ShoppingCart.historyCategoryDishLimit = turnInfo.slu_dishes_number;
    //         // const CURRROUND = turnInfo.rule_gnr_turn ? parseInt(turnInfo.rule_gnr_turn) : 1;
    //         // ShoppingCart.globalRound = CURRROUND
    //         // $ 上一轮提交的菜品数量

    //         const LAST_DISHCOUNT = _.get(turnInfo, `customer_dish_num.${CUSTOMER}`) ? turnInfo.customer_dish_num[CUSTOMER] : 0;

    //         // 如果处于倒计时 && 已提交数等于最大点餐数
    //         if (Store.getState().isShowTime && `${LAST_DISHCOUNT + currentTurnCound}` === `${this.state.turn_dishes}`) {
    //             this.setState({
    //                 turnInfo,
    //                 historyDishNum: LAST_DISHCOUNT,
    //                 turnCount: getCacheField('isShowTime') ? (LAST_DISHCOUNT + currentTurnCound) : currentTurnCound,
    //                 waitForNextTurn: true
    //             })
    //         } else {
    //             this.setState({
    //                 turnInfo,
    //                 historyDishNum: LAST_DISHCOUNT,
    //                 turnCount: getCacheField('isShowTime') ? (LAST_DISHCOUNT + currentTurnCound) : currentTurnCound,
    //             })
    //         }
    //         Store.dispatch({
    //             type: 'SET_CACHING',
    //             path: 'turnInfo',
    //             value: turnInfo,
    //         });

    //     } catch (error) {
    //         this.messengerModule.say({
    //             message: error,
    //             level: "Warning",
    //         });
    //     }
    // }

    // // $ 重新获取轮次规则
    // public async getOrderTurn() {
    //     const ORDERID = StateManager.getFromCache('orderTab.orderId')
    //     const CUSTOMER = getCacheField('orderTab.customer');
    //     try {
    //         let settingInfo = getCacheField('settingInfo')
    //         // 轮次规则
    //         let turnInfo = await DefaultRequest.getTurnInfo(
    //             ORDERID,
    //             _.get(settingInfo, '0.value.menu_id', 9)
    //         );
    //         let currentTurnCound = 0;
    //         // 统计现有的购物车菜品数量

    //         if (_.has(ShoppingCart.metaData, `${ShoppingCart.globalRound}.${CUSTOMER}`)) {
    //             Object.values(ShoppingCart.metaData[ShoppingCart.globalRound][CUSTOMER]).forEach((customerItem) => {
    //                 if (customerItem._origin.not_joining_global_limit !== 1) {
    //                     currentTurnCound += customerItem.count + customerItem.excessCount
    //                 }
    //             })
    //         }
    //         ShoppingCart.historyCategoryDishLimit = turnInfo.slu_dishes_number;
    //         // const CURRROUND = turnInfo.rule_gnr_turn ? parseInt(turnInfo.rule_gnr_turn) : 1;
    //         // ShoppingCart.globalRound = CURRROUND
    //         // $ 上一轮提交的菜品数量

    //         const LAST_DISHCOUNT = _.get(turnInfo, `customer_dish_num.${CUSTOMER}`) ? turnInfo.customer_dish_num[CUSTOMER] : 0;
    //         console.log(`上一轮提交的菜品数量：${LAST_DISHCOUNT}，统计现有数量：${currentTurnCound}`)

    //         if (!ShoppingCart.GLOBAL_SELF_ORDER_RULE) {
    //             this.setState({
    //                 turnInfo,
    //                 historyDishNum: LAST_DISHCOUNT,
    //                 turnCount: getCacheField('isShowTime') ? (LAST_DISHCOUNT + currentTurnCound) : currentTurnCound,
    //             }, () => {
    //                 ShoppingCart.turnCount = this.state.turnCount
    //                 this.initializeTurnData(turnInfo);
    //             })
    //         }
    //         else {

    //             this.setState({
    //                 turnInfo,
    //                 historyDishNum: LAST_DISHCOUNT,
    //                 turnCount: getCacheField('isShowTime') ? (LAST_DISHCOUNT + currentTurnCound) : currentTurnCound,
    //             }, () => {
    //                 ShoppingCart.turnCount = this.state.turnCount
    //                 this.initializeTurnData(turnInfo);
    //             });
    //         }
    //         Store.dispatch({
    //             type: 'SET_CACHING',
    //             path: 'turnInfo',
    //             value: turnInfo,
    //         });

    //     } catch (error) {
    //         this.messengerModule.say({
    //             message: error,
    //             level: "Warning",
    //         });
    //     }
    // }

    // /**
    //  * 初始化轮次相关数据 （弃用）
    //  * @param turnInfo 轮次规则
    //  * @param isCountDown 是否显示倒计时
    //  */
    // public async initializeTurnData(turnInfo: TurnInfo, isCountDown: boolean = true) {
    //     const { turn_dishes, turnCount, historyDishNum } = this.state;
    //     const { customer } = this.props;
    //     const settingInfo = getCacheField('settingInfo');
    //     const openTurn = settingInfo[1].value ? settingInfo[1].value.enable : '';
    //     // console.log('initializeTurn-ROUND:', ShoppingCart.globalRound);
    //     // 检查轮次是否存在
    //     if (!_.has(ShoppingCart.metaData, `${ShoppingCart.globalRound}`)) _.set(ShoppingCart.metaData, `${ShoppingCart.globalRound}`, {});
    //     // 检查顾客是否存在
    //     if (customer && !_.has(ShoppingCart.metaData, `${ShoppingCart.globalRound}.${customer}`)) _.set(ShoppingCart.metaData, `${ShoppingCart.globalRound}.${customer}`, []);
    //     // 是否开启轮次规则
    //     if (openTurn) {

    //         // 当前轮开始时间
    //         let rule_gnr_time_start = turnInfo.rule_gnr_time_start;
    //         if (rule_gnr_time_start) {
    //             // 当前时间戳
    //             let nowDate = new Date().getTime();
    //             // 每轮次分钟数

    //             let turn_mins = getSettingInfo('rule-global-turn-limit', 'value').turn_mins;
    //             // 轮次开始时间+每轮次分钟数
    //             let turnEndTime = new Date(rule_gnr_time_start).getTime() + turn_mins * 60 * 1000;
    //             // console.log('turnCount:', turnCount, 'historyDishNum:', historyDishNum, 'turn_dishes:', turn_dishes);
    //             // $ 区分点满和未点满情况
    //             // => 当前时间 < 轮次结束时间 && 轮次没有点满
    //             if (nowDate < turnEndTime && turnCount < turn_dishes) {
    //                 // 还没点满
    //                 this.setState({ waitForNextTurn: false });
    //                 this.changeSecond(turnEndTime);
    //                 return;
    //             }
    //             // => 当前时间 < 轮次结束时间 && 轮次点满
    //             if (nowDate < turnEndTime && turnCount === turn_dishes) {
    //                 if (historyDishNum === turn_dishes) {
    //                     // 已点满
    //                     isCountDown && this.setState({ waitForNextTurn: true });
    //                     this.changeSecond(turnEndTime);
    //                 }
    //                 return;
    //             } else {
    //                 console.log('nextTurn');
    //                 this.enterToNextTurn();
    //             }

    //         } else {
    //             this.setState({ waitForNextTurn: false });
    //             // console.log('时间格式为：', rule_gnr_time_start);
    //             // 清除轮次倒计时
    //             clearInterval(this.dishTimer);
    //             this.enterToNextTurn();
    //         }
    //     } else {
    //         ShoppingCart.globalRound = 0;
    //     }
    // }

    // $ 初始化菜品相关规则
    public async initDishRules() {
        const { autonomous } = this;
        // $ 菜品基础规则参数

        // 每个人每轮次最大点餐数量
        let num = 1
        if (getSettingInfo('rule-global-turn-limit', 'value')) {
            num = getSettingInfo('rule-global-turn-limit', 'value').turn_dishes;
        }
        //每轮次最大点餐数量
        // alert(`num:${num}`)
        ShoppingCart.globalRoundMaxOrder = num * 1;
        // 顾客数量
        // console.log(this.state.person, '===-顾客数量');
        ShoppingCart.customerNum = this.state.person;
        // alert(JSON.stringify({person, num}));
        // 每轮最大点餐数量
        let turn_dishes = autonomous.status ? num * 1 : this.state.person * num;

        this.setState({ turn_dishes })

    }
    /**
     * 倒计时
     * @param endTime 轮次结束时间
     */
    changeSecond = (endTime: number) => {
        clearInterval(this.dishTimer);
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'isShowTime',
            value: true
        })
        this.updateTurnCount();
        const diffTimeStamp = this.diffTimeStamp;
        ServerShoppingCart.isToNextTurn = false;
        this.dishTimer = setInterval(() => {
            // let nowDate = new Date().getTime();
            let nowDate = setLocalDateByDiff(diffTimeStamp);
            let showTimeString = endTime - nowDate;
            // 判断当前时间是否超过结束时间
            if (nowDate < endTime) {
                this.setState({ showTimeString });
                // 限定x秒区间内不能操作菜品
                if ((showTimeString / 1000) < 5) {
                    Store.dispatch({
                        type: 'SET_CACHING',
                        path: 'roundTime',
                        value: (showTimeString / 1000)
                    })
                    WebsocketClient.emit('CANCLE_DISH_EDIT')
                }
            } else {
                this.setState({ showTimeString: 0 });
                ServerShoppingCart.isToNextTurn = true;
                // 倒计时结束进入下一轮
                this.enterToNextTurnSSC();
            }
        }, 1000)
    }

    /**
     * - 进入下一轮 (弃用)
     * - 更新轮次信息
     */
    // public async enterToNextTurn() {
    //     let turnCount = 0;
    //     const customer = getCacheField('orderTab.customer');
    //     this.setState({
    //         waitForNextTurn: false,
    //     }, async () => {

    //         Store.dispatch({
    //             type: 'SET_CACHING',
    //             path: 'isShowTime',
    //             value: false
    //         })
    //         // （逻辑加固）检测顾客"0"是否存在，存在赋值空数组
    //         if (_.has(ShoppingCart.metaData, `${ShoppingCart.globalRound}.0`)) {
    //             _.set(ShoppingCart.metaData, `${ShoppingCart.globalRound}.0`, [])
    //         }
    //         clearInterval(this.dishTimer)
    //         // 存储当前轮次未提交的菜品
    //         let saveDishes: RoundCustomerMetaData = {};
    //         if (_.get(getCacheField('shoppingCart'), `${ShoppingCart.globalRound}`)) {
    //             saveDishes = _.cloneDeep(_.get(getCacheField('shoppingCart'), `${ShoppingCart.globalRound}`))
    //         }

    //         // $ 进入下一轮时,清空上一轮次的购物车菜品
    //         getCacheField('personArr').forEach((customer: string) => {
    //             ShoppingCart.clearCart(ShoppingCart.globalRound, customer);
    //         })

    //         // 轮次规则
    //         let TURNINFO = await DefaultRequest.getTurnInfo(
    //             getCacheField('orderTab.orderId'),
    //             Store.getState().settingInfo[0] ? Store.getState().settingInfo[0].value.menu_id : 9
    //         );

    //         // 倒计时结束 更新轮次信息
    //         const CURRROUND = TURNINFO.rule_gnr_turn ? parseInt(TURNINFO.rule_gnr_turn) + 1 : 1;
    //         ShoppingCart.globalRound = CURRROUND;
    //         // $ 非自助点餐模式
    //         if (!ShoppingCart.GLOBAL_SELF_ORDER_RULE) {
    //             // 检查轮次是否存在
    //             if (!_.has(ShoppingCart.metaData, `${ShoppingCart.globalRound}`)) _.set(ShoppingCart.metaData, `${ShoppingCart.globalRound}`, {});

    //             // 如果当前轮次大于等于最大回合数 则跳过此步骤 （非自助点餐模式）
    //             if (ShoppingCart.globalRound <= ShoppingCart.globalRoundMax) {
    //                 // 将上一轮未提交的菜品推到下一轮 && 购物车有数据
    //                 if (saveDishes[customer] && saveDishes[customer].length) {
    //                     _.set(ShoppingCart.metaData, `${ShoppingCart.globalRound}`, saveDishes)
    //                 }
    //             } else {
    //                 // $ 清空购物车页面,更新视图层
    //                 console.log('超过最大回合数--清空购物车页面,更新视图层');
    //                 WebsocketClient.emit('CLEAT_DISH_VIEW');
    //             }
    //             // （逻辑加固）检测顾客"0"是否存在，存在赋值空数组
    //             if (_.has(ShoppingCart.metaData, `${ShoppingCart.globalRound}.0`)) {
    //                 _.set(ShoppingCart.metaData, `${ShoppingCart.globalRound}.0`, [])
    //             }
    //         }
    //         // $ 自助点餐模式
    //         else {
    //             // $ 如果当前轮次大于等于最大回合数 则跳过此步骤 ( 自助点餐模式处理)
    //             if (ShoppingCart.globalRound <= ShoppingCart.globalRoundMax) {
    //                 // 将上一轮未提交的菜品推到下一轮 && 购物车有数据
    //                 // 检查轮次是否存在
    //                 if (!_.has(ShoppingCart.metaData, `${ShoppingCart.globalRound}`)) _.set(ShoppingCart.metaData, `${ShoppingCart.globalRound}`, {});

    //                 getCacheField('personArr').forEach((customer: string) => {
    //                     let saveCustomerDish = _.get(saveDishes, `${customer}`)

    //                     if (saveCustomerDish && saveCustomerDish.length) {
    //                         _.set(ShoppingCart.metaData, `${ShoppingCart.globalRound}.${customer}`, saveCustomerDish)
    //                     } else {
    //                         _.set(ShoppingCart.metaData, `${ShoppingCart.globalRound}.${customer}`, [])
    //                     }
    //                 })
    //                 // （逻辑加固）检测顾客"0"是否存在，存在赋值空数组
    //                 if (_.has(ShoppingCart.metaData, `${ShoppingCart.globalRound}.0`)) {
    //                     _.set(ShoppingCart.metaData, `${ShoppingCart.globalRound}.0`, [])
    //                 }
    //             } else {
    //                 // $ 清空购物车页面,更新视图层
    //                 console.log('超过最大回合数--清空购物车页面,更新视图层');
    //                 WebsocketClient.emit('CLEAT_DISH_VIEW')
    //             }
    //         }

    //         // 计算(受轮次控制)当前购物车菜品数量
    //         const cartRoundData = ShoppingCart.metaData[ShoppingCart.globalRound];
    //         if (_.get(cartRoundData, `${customer}`)) {
    //             Object.values(cartRoundData[customer]).forEach((customerItem) => {
    //                 if (customerItem._origin.not_joining_global_limit !== 1) {
    //                     turnCount += customerItem.count + customerItem.excessCount
    //                 }
    //             })
    //         }

    //         // 缓存购物车
    //         Store.dispatch({
    //             type: 'SET_CACHING',
    //             path: 'shoppingCart',
    //             value: ShoppingCart.metaData
    //         })
    //         // 记录当前轮次
    //         Store.dispatch({
    //             type: 'SET_CACHING',
    //             path: 'advGlobalRound',
    //             value: ShoppingCart.globalRound
    //         })
    //         Store.dispatch({
    //             type: 'SET_CACHING',
    //             path: 'roundTime',
    //             value: -1
    //         })

    //         ShoppingCart.turnCount = turnCount;
    //         this.setState({ turnCount });
    //         // alert(`第${ShoppingCart.globalRound}轮`)
    //         console.log('enterToNextTurn', this.dishTimer, ShoppingCart.globalRound);
    //     });
    // }

    /**
     * 更新自己的购物车提交
     * @param data
     */
    public cartCommitListener = async (data: CartCommitEventObject) => {
        console.log('更新自己的购物车提交', data);
        clearInterval(this.dishTimer);
        let cacheData = StateManager.getFromCache(['orderTab', 'advGlobalRound']);
        let advGlobalRound = cacheData['advGlobalRound'];
        let orderId = cacheData['orderTab']['orderId'];
        let customer = cacheData['orderTab']['customer'];
        // 轮次规则
        let turnInfo = data.turnInfo;
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'turnInfo',
            value: turnInfo
        })
        // let turnCount: number = 0;
        // $ 初始化购物车历史记录
        const cartHistory = await DefaultRequest.getHistoryDish(
            orderId,
            Store.getState().settingInfo[0] ? Store.getState().settingInfo[0].value.menu_id : 9,
            'round,dish,type,rule'
        )
        // 更新自主点餐模式
        ShoppingCart.historyDishNumMetaData = cartHistory.dish_round_customer_data;
        ShoppingCart.historyDishRulesMetaData = cartHistory.dishRuleData;

        // $  是否同一设备的用户, true 则更新浮窗数量
        if (data.customer === customer) {
            // $ 统计当前轮次提交的历史数量
            let historyDishNum: number = 0;
            Object.keys(cartHistory.dish_round_customer_data).forEach((itemKey) => {
                if (_.has(cartHistory.dishRuleData, `${itemKey}`) && _.get(cartHistory.dishRuleData, `${itemKey}.not_joining_global_limit`) !== 1) {
                    if (_.has(cartHistory.dish_round_customer_data, `${itemKey}.${advGlobalRound}.${customer}`)) {
                        historyDishNum += _.get(cartHistory.dish_round_customer_data, `${itemKey}.${advGlobalRound}.${customer}`);
                    }
                }
            })
            if (historyDishNum >= this.state.turn_dishes) {
                historyDishNum = this.state.turn_dishes
            }
            this.setState({ historyDishNum }, async () => {
                this.initTrunInfoSSC(turnInfo);
            });
            return;
        }
        this.initTrunInfoSSC(turnInfo);
    }

    // /**
    //  * 更新其他设备菜品的计数
    //  * @param data
    //  */
    // public updateDishCountListener = async (data: UpdateDishCountEventObject) => {
    //     const customer = getCacheField('orderTab.customer');
    //     const turnInfo = data.turnInfo;
    //     let turnCount: number = 0;
    //     let historyDishNum = 0;
    //     const globalRound = data.globalRound ? data.globalRound : ShoppingCart.globalRound;
    //     if (_.has(ShoppingCart.metaData, `${globalRound}.${customer}`)) {
    //         Object.values(ShoppingCart.metaData[globalRound][customer]).forEach((customerItem) => {
    //             if (customerItem._origin.not_joining_global_limit !== 1) {
    //                 turnCount += customerItem.count + customerItem.excessCount
    //             }
    //         })
    //     }
    //     historyDishNum = turnInfo.customer_dish_num[customer] ? turnInfo.customer_dish_num[customer] : 0;

    //     // 判断是否在倒计时
    //     let isRrecordCount = 0

    //     ShoppingCart.turnCount = historyDishNum;
    //     if (getCacheField('isShowTime')) {
    //         isRrecordCount = historyDishNum + turnCount;
    //         this.setState({
    //             turnCount: isRrecordCount,
    //             historyDishNum
    //         })
    //     } else {
    //         ShoppingCart.turnCount = historyDishNum
    //         this.setState({ turnCount, historyDishNum })
    //     }
    // }

    // /**
    //  * 更新自己的浮窗计数
    //  * @param data
    //  */
    // public updateDishCountSelfListerner = async (data: UpdateSelfDishCountEventObject) => {
    //     const customer = getCacheField('orderTab.customer');
    //     const turnInfo = data.turnInfo;
    //     let turnCount: number = 0;
    //     let historyDishNum = 0;
    //     // $
    //     if (ShoppingCart.metaData[ShoppingCart.globalRound][customer]) {
    //         Object.values(ShoppingCart.metaData[ShoppingCart.globalRound][customer]).forEach((customerItem) => {
    //             if (customerItem._origin.not_joining_global_limit !== 1) {
    //                 turnCount += customerItem.count + customerItem.excessCount
    //             }
    //         })
    //     }

    //     historyDishNum = _.get(turnInfo, `customer_dish_num.${customer}`) ? turnInfo.customer_dish_num[customer] : 0;
    //     // 判断是否在倒计时
    //     let isRrecordCount = 0
    //     if (getCacheField('isShowTime')) {
    //         isRrecordCount = historyDishNum + turnCount;
    //         ShoppingCart.turnCount = isRrecordCount
    //         this.setState({
    //             turnCount: isRrecordCount,
    //             historyDishNum
    //         })
    //     } else {
    //         ShoppingCart.turnCount = turnCount
    //         this.setState({ turnCount, historyDishNum })
    //     }
    // }




    // *********************
    // 服务端购物车
    // *********************

    /**
     *  获取轮次规则
     *
     */
    public async getOrderTurnSSC() {
        const orderTab = StateManager.getFromCache('orderTab');
        const CUSTOMER = getCacheField('orderTab.customer');
        try {
            let settingInfo = getCacheField('settingInfo')
            // 轮次规则
            let turnInfo = await DefaultRequest.getTurnInfo(orderTab.orderId, _.get(settingInfo, '0.value.menu_id', 9));
            // 上一轮提交的参与轮次的菜品数量(参入轮次)
            const LAST_DISHCOUNT = _.get(turnInfo, `customer_dish_num.${CUSTOMER}`, 0);

            this.setState({
                turnInfo,
                historyDishNum: LAST_DISHCOUNT,
            }, () => {
                this.initTrunInfoSSC(turnInfo);
            })
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'turnInfo',
                value: turnInfo,
            });
        } catch (error) {
            this.messengerModule.say({
                message: error,
                level: "Warning",
            });
        }
    }

    /**
     * 初始化轮次详情
     *
     * - "自主模式"且开启"一轮一次发送"：用户A点发送（不管是否点满）就进入倒计时，B不可再点;
     * - "非自主模式"且开启"一轮一次发送"：用户A（只有一个用户）点发送就进入倒计时;
     *
     * - "自主模式"且关闭"一轮一次发送"：用户A未点满，也进入倒计时，期间可点菜品，到时间后未发送则将未发送菜品推到下一轮。用户B同样;
     * - "非自主模式"且关闭"一轮一次发送"：用户A（只有一个用户）未点满，也进入倒计时，期间可点菜品（点满则不能点菜品），到时间后未发送则将未发送菜品推到下一轮;
     *
     *  - 倒计时结束都要进入下一轮
     */
    public async initTrunInfoSSC(turnInfo: TurnInfo) {
        const { turn_dishes, historyDishNum } = this.state;
        // const { customer } = this.props;
        const openTurnRule = getSettingInfo('rule-global-turn-limit', 'value');
        const diffTimeStamp = await getSeverAndLoacalDiff();
        this.diffTimeStamp = diffTimeStamp;
        Store.dispatch({
            type: 'SET_CACHING',
            path: 'diffTimeStamp',
            value: diffTimeStamp,
        })
        const openTurn = openTurnRule?.enable;
        // 是否开启轮次规则
        if (openTurn) {
            // 当前轮开始时间
            let rule_gnr_time_start = turnInfo?.rule_gnr_time_start;
            if (rule_gnr_time_start) {
                // 当前时间戳
                // let nowDate = new Date().getTime();
                let nowDate = setLocalDateByDiff(diffTimeStamp);
                // 每轮次分钟数
                let turn_mins = openTurnRule?.turn_mins;
                // 轮次开始时间+每轮次分钟数
                let turnEndTime =  moment(rule_gnr_time_start).valueOf() + turn_mins * 60 * 1000;
                // 当前时间 < 轮次结束时间
                if (nowDate < turnEndTime) {
                    if (historyDishNum === turn_dishes) {
                        // turnCount === turn_dishes
                        // 本轮次已提交的菜品数量,达到最大限制
                        this.setState({ waitForNextTurn: true });
                    }
                    // 倒计时结束时将菜品推到下一轮（服务端购物车处理）
                    this.changeSecond(turnEndTime);
                    return;
                }
            } else {
                this.setState({ waitForNextTurn: false });
                // 清除轮次倒计时
                clearInterval(this.dishTimer);
                ServerShoppingCart.isToNextTurn = true;
            }
        } else {
            // ShoppingCart.globalRound = 0;
        }
    }

    /**
     * 监听用户选中ID（其他用户进入初始化一遍）重新获取轮次规则
     *
     */
    public async orderGetOrderTurnSSC() {
        const CUSTOMER = getCacheField('orderTab.customer');
        let cacheData = StateManager.getFromCache(['orderTab.orderId', 'advGlobalRound']);
        try {
            let settingInfo = getCacheField('settingInfo');
            // 轮次规则
            let turnInfo = await DefaultRequest.getTurnInfo(cacheData['orderTab.orderId'], _.get(settingInfo, '0.value.menu_id', 9));
            let res = ServerShoppingCart.getCurrentCustomerCart({});
            // 统计现有的购物车菜品数量
            let currentTurnCount = res?.r3TotalNum;
            // 拿参与轮次规则的菜品 上一轮提交的菜品数量（参与轮次的菜品）
            const LAST_DISHCOUNT = _.get(turnInfo, `customer_dish_num.${CUSTOMER}`, 0);

            // 如果处于倒计时 && 已提交数等于最大点餐数
            this.setState({
                turnInfo,
                historyDishNum: LAST_DISHCOUNT,
                turnCount: getCacheField('isShowTime') ? (LAST_DISHCOUNT + currentTurnCount) : currentTurnCount,
            })

            Store.dispatch({
                type: 'SET_CACHING',
                path: 'turnInfo',
                value: turnInfo,
            });

        } catch (error) {
            this.messengerModule.say({
                message: error,
                level: "Warning",
            });
        }
    }

    /**
     * 监听服务端购物车初始化
     * 执行更新悬浮窗计数等操作
     * @param data
     */
    public initCartListener = (data: InitCart) => {
        // console.log("悬浮窗监听 Init_Cart", data)
        ServerShoppingCart.updateSeverShoppingCartModule(data.data);
        this.updateTurnCount(data);
    }
    /**
     * 监听服务端购物车变化
     * 执行更新悬浮窗计数等操作
     * @param data
     */
    public updateCartListener = (data: UpdateCart) => {
        // console.log("悬浮窗监听 UPDATE_CART", data)
        if (data?.data?.tableId === ServerShoppingCart?.metaData?.tableId) {
            ServerShoppingCart.updateSeverShoppingCartModule(data.data);
            this.updateTurnCount(data);
        }
    }

    /**
     * 根据服务端购物车的菜品数量
     * 更新悬浮窗计数
     */
    public updateTurnCount = (data: InitCart | UpdateCart) => {
        let roundListDetail = ServerShoppingCart.getCurrentCustomerCart({});
        //  服务端购物车是否需要加历史数量 ，本轮次上次提交未选满
        this.setState({
            turnCount: roundListDetail?.r3TotalNum + (getCacheField('isShowTime') ? roundListDetail?.r3HistoryTotalNum : 0)
        })
    }

    /**
     * 服务端购物车 - 推送轮次
     *  - 关闭"一轮一次提交"
     *    - 本轮已提交过，未点满，可继续点。到时间结束，则将未提交的菜品，推到下一轮次
     */
    public toNextTurnListener = (data: UpdateCart) => {
        console.log("推送轮次 TO_NEXT_TURN - 注意是否是同一购物车", data)
        if (!!_.get(data, ['parameter', 'isToNextTurn'])) {
            this.messengerModule.say({
                message: `${i18n.t('order_cart_page_text_sync_round_info_success')}`,
                level: 'Success',
            })
        }
        // $ 注意是否是同一购物车
        if (data?.data?.tableId === ServerShoppingCart?.metaData?.tableId) {
            ServerShoppingCart.updateSeverShoppingCartModule(data.data, true);
            ServerShoppingCart.isToNextTurn = true;
            this.setDisableFalse && clearTimeout(this.setDisableFalse);
            this.setDisableFalse = setTimeout(() => {
                console.log('10s到，放开disableToNext限制了')
                ServerShoppingCart.disableToNext = false;
            }, 10000)
        }
        ServerShoppingCart.getOrderTurn();
    }

    /**
     * 倒计时结束
     * - 推送轮次，将范围内的购物车菜品移至下一轮
     */
    public async enterToNextTurnSSC() {
        ServerShoppingCart.isToNextTurn = true;
        this.setState({
            waitForNextTurn: false,
        }, async () => {
            clearInterval(this.dishTimer)
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'isShowTime',
                value: false
            })
            Store.dispatch({
                type: 'SET_CACHING',
                path: 'roundTime',
                value: -1
            })
            let res = ServerShoppingCart.getCurrentCustomerCart({});
            this.setState({ turnCount: res?.r3TotalNum });
        });
    }



    public render() {
        const { hideModal, turn_dishes, turnCount, showTimeString, guidePageHideDishes } = this.state;
        // 倒计时
        let showTime = moment(showTimeString).format('mm:ss')
        return (
            // @ts-ignore
            <GuideTooltips
                placement="left"
                arrow
                open={this.props.globalLimitEnable ? guidePageHideDishes : false}
                title={i18n.t('novice_guide_text_round_dish')}
                toopTipStyle={{
                    popperIndex: this.state.updateToolTipStatus,
                    height: 30,
                    arrowTop: 'auto !important'
                }}
            >
                <div className={hideModal ? 'floating' : 'floating hide'}>
                    <div className="left" onClick={() => {
                        this.setState({ hideModal: !hideModal })
                    }
                    }>
                        <ArrowBackIosOutlinedIcon
                            className={hideModal ? 'hide' : ''}
                        />
                        <ArrowForwardIosOutlinedIcon
                            className={hideModal ? '' : 'hide'}
                        />
                    </div>
                    <div className="right">
                        <div className="tableName">
                            <div className="table-name-box">
                                <div className="freebrrak-icon"></div>
                                <div>{getCacheField('tableName')}</div>
                            </div>

                            <div style={{
                                width: 80, fontWeight: 'normal',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}>
                                <PersonIcon style={{ fontSize: 16 }} />
                                <div>{this.state.person}</div>
                            </div>

                        </div>
                        {/* {
                                waitForNextTurn ?
                                    <div className="rightContent">
                                        <div >{i18n.t('general_text_next_turn_time')}</div>
                                        <div>{showTime}</div>
                                    </div>
                                    :
                                    <div className="rightContent">
                                        <div >{i18n.t('general_text_ordered')}</div>
                                        <div>{turnCount}/{turn_dishes}</div>
                                    </div>
                            } */}
                        {
                            this.props.globalLimitEnable &&
                            <>
                                {<div className="rightContent ">
                                    <div >{i18n.t('general_text_ordered')}</div>
                                    <div>{turnCount || 0}/{turn_dishes || 0}</div>
                                </div>}
                                {showTimeString > 0 && <div className="rightContent rightContentTurnBox">
                                    <div >{i18n.t('general_text_next_turn_time')}</div>
                                    <div>{showTime}</div>
                                </div>}
                            </>
                        }
                    </div>
                </div>
            </GuideTooltips>
        );
    }
}

export default withSnackbar(Floating)

// *********************
// Types
// *********************
type Props = {
    // 轮次规则限制是否开启
    globalLimitEnable: boolean;
    // 顾客
    customer: string;
    // 轮次规则
    turnInfo: TurnInfo;
} & WithSnackbarProps;

type State = {
    // 自主点餐
    // autonomous: {
    //     status: boolean;
    // }
    // 是否展示弹窗
    hideModal: boolean;
    // 是否等待下一轮
    waitForNextTurn: boolean;
    // 倒计时时间戳
    showTimeString: number;
    // 最大点餐数量
    turn_dishes: number;
    // 每轮次分钟数
    turn_mins: number;
    // 轮次规则
    turnInfo: TurnInfo;
    // 当前轮次已经数
    turnCount: number;
    // 开桌点餐相关规则
    settingInfo: Array<SettingInfo>;
    // 人数
    person: number;
    // 上一轮用户点的历史数量
    historyDishNum: number;
    // 用户选中ID 后显示气泡
    updateToolTipStatus: boolean;
    // 记录用户第一次进入，是否显示气泡
    guidePageHideDishes: boolean;
    // 桌台id--用于触发视图render
    tableId: number;
};
